import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
gsap.registerPlugin(ScrollTrigger);



export default class Offres extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      offres: []
    };
  }

  mount() {
    let that = this;


  }


}